
import { EventSourcePolyfill } from 'event-source-polyfill'
import { mapGetters, mapState, mapActions } from 'vuex'
import QRCode from 'qrcodejs2'
import { jsFn } from '@/utils/js-fn'
import profile from '@/utils/profile'
import { Base64 } from 'js-base64'
import CountryCode from '@/components/tool/countryCode/Index.vue'

export default {
    name: 'home',
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('error_1')))
            } else if (value.search(/^\+/) === 0) {
                callback(new Error(this.$t('error_26')))
            } else {
                callback()
            }
        }
        const validatePasswordCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('error_1')))
            } else {
                callback()
            }
        }
        // 驗證碼格式驗證
        const validVCode = (rule, value, callback) => {
            if (jsFn.isEmpty(value)) {
                callback(new Error(this.$t('error_1')))
            }else {
                callback()
            }
        }
        // 帳號格式驗證
        const validateAccount = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('error_1')))
            } else if (this.wechatRgForm.countryCode === '') {
                callback(new Error(this.$t('error_6')))
            } else if (!(/^[0-9]*$/.test(value))) {
                callback(new Error(this.$t('error_7')))
            } else {
                callback()
            }
        }
        return {
            verfTime: 0, // 倒數秒數控制
            callback: '',
            loginForm: {
                loginId: '',
                password: ''
            },
            loginRule: {
                loginId: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                password: [
                        { validator: validatePasswordCheck, trigger: 'blur' }
                    ]
            },
            ticket: '', // 快速登入票卷
            qrloginFlag: false,
            sseSurvive: false,
            esState:'',
            joinQRcode: undefined,
            isCN: jsFn.isCN(), // 是否為大陸站
            isHabookaclass: jsFn.isHabookaclass(), // 是否domain為habookaclass
            loading: false,
            redirectUrlByThird: document.location.origin + '/',
            validEducloudFlag: false,
            validWechatFlag: false,
            countdown: false, // 倒數計時中
            bindForm: {
                account: '',
                password: '',
                openId: '',
                grantType: ''
            },
            bindRules: {
                account: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePasswordCheck, trigger: 'blur' }
                ]
            },
            wechatRgForm: {
                countryCode: '',
                phone: '',
                vCode: '',
                openId: '',
                grantType: ''
            },
            wechatRgRules: {
                phone: [
                    { validator: validateAccount, trigger: 'blur' }
                ],
                vCode: [
                    { validator: validVCode, trigger: 'blur' }
                ]
            },
            bindErrText: '',
            btnLoading: false,
            vCodeLoading: false,
            linkCount_1: 0,
            linkCount_2: 0
        }
    },
    head: {
        title: function() {
            return {
                inner: this.$t('pageTitle_1'),
                separator: ' '
                // complement: 'My Complement'
            }
        }
    },
    computed: {
        ...mapState({
            loginFlag: state => state.loginFlag,
            verCountdownSec: state => state.verCountdownSec
        }),
        ...mapGetters({
            pageLang: 'getLang',
            isHiTA_UA: 'isHiTA_UA',
            isAClassONE_UA: 'isAClassONE_UA',
            isApp: 'isApp'
        }),
        accFormat: function() {
            let acc = this.wechatRgForm.phone
            if (this.wechatRgForm.countryCode === 886 && acc.indexOf(0) === 0) {
                acc = acc.substr(1)
            }
            return acc
        },
        sendBtnText: function() { // 發送驗證信與驗證碼字串判斷
            let str = this.$t('public_4')
            let timeStr = ''
            if (this.countdown) timeStr = '(' + this.verfTime + ')'

            return str + timeStr
        },
        pinCodeSwitch: function() {
            let disabledFlag = false
            if (this.wechatRgForm.countryCode === '' || this.wechatRgForm.phone === '') disabledFlag = true
            return disabledFlag
        }
    },
    created: function() {
        // QrCode 模式預先啟動
        // this.qrcodrLogin() 暫時註解

        // 驗證碼倒數時間設定
        this.verfTime = this.verCountdownSec

        // 如果有callback 先存起來
        this.getUrlQuerCallback('callback')

        // oauth登入
        let code = this.$route.query.code === undefined ? '' : this.$route.query.code
        let state = this.$route.query.state === undefined ? '' : this.$route.query.state
        let nonce = this.$route.query.nonce === undefined ? '' : this.$route.query.nonce
        let ticket = this.$route.query.ticket === undefined ? '' : this.$route.query.ticket
        let clientId = this.$route.query.client_id === undefined ? '' : this.$route.query.client_id
        let redirectUri = this.$route.query.redirect_uri === undefined ? '' : this.$route.query.redirect_uri
        let autoLink = this.$route.query.autolink === undefined ? '' : this.$route.query.autolink

        if(this.$route.query.nLang) {
            this.langChange(this.$route.query.nLang)
        }

        // 教育魔方回跳只帶 sessionId 回來，沒有 code/state
        let mofangSid = this.$route.query.sessionId || this.$route.query.sessionid || this.$route.query.session_id || ''

        if (!jsFn.isEmpty(mofangSid)) { // 教育魔方登入
            this.putUserCode(mofangSid, 'mofang')
        } else if (!jsFn.isEmpty(redirectUri) && !jsFn.isEmpty(clientId) && !jsFn.isEmpty(state) && !jsFn.isEmpty(nonce)) { // 醍摩豆Oauth
            // 不動作
            // 其他服務的Oauth流程
            sessionStorage.setItem('redirect_uri', redirectUri)
            sessionStorage.setItem('clientId', clientId)
            sessionStorage.setItem('state', state)
            sessionStorage.setItem('nonce', nonce)
        } else if (!jsFn.isEmpty(code) && !jsFn.isEmpty(state)) { // 社群帳號登入
            switch(state) {
                case 'facebook':
                case 'google':
                case 'wechat':
                case 'ding':
                case 'educloudtw':
                    this.putUserCode(code, state)
                break
                default:
                    this.jumpOCode(code, state)
            }
        } else if (!jsFn.isEmpty(code)) { // 大雲快速登入
            this.codeLogin(code)
        } else if (!jsFn.isEmpty(ticket)) { // 舊版票券登入一樣走Code
            this.codeLogin(ticket)
        } else if (!jsFn.isEmpty(autoLink)) { // 自動連結第三方
            let existAry = ['facebook', 'google', 'wechat', 'ding', 'educloudtw', 'mofang']
            console.log(existAry.indexOf(autoLink), 'existAry')
            if(existAry.indexOf(autoLink) >= 0) {
                this.getProviderOauth(autoLink)
            } else {
                this.$Message.warning({
                    content: '指定的autolink不存在',
                    duration: 5,
                    closable: true
                })
            }
        }
    },
    methods: {
        ...mapActions(['setPageLang']),
        langChange(val) {
            this.$i18n.locale = val
            this.setPageLang(val)
        },
        getUrlQuerCallback(key) {
            let url = decodeURIComponent(window.location.href)
            if (url.indexOf(key) >= 0) {
                let callbackUrl = url.substr(url.indexOf(key) + (key.length + 1))
                this.callback = callbackUrl
                sessionStorage.setItem(key, callbackUrl)
            }
        },
        // 第三方跳轉
        getProviderOauth: function(provider) {
            document.location.href = profile.communityUrl(provider, this.redirectUrlByThird)
        },
        // 登入檢查
        loginSubmit:async function(name) {
            switch(name) {
                case 'bindForm': // 這個流程目前只有教育雲在用
                    this.$refs[name].validate(async(valid) => {
                        // 清空錯誤訊息
                        this.bindErrText = ''

                        if (valid) {
                            this.btnLoading = true // 開啟加載畫面
                            let isFail = false // 失敗flag

                            // 詢問帳號是否有效
                            await this.$store.dispatch('coreApi/login', { id: this.bindForm.account, pass: this.bindForm.password }).catch(e => {
                                isFail = true
                            })

                            if (isFail) {
                                this.bindErrText = this.$t('error_2')
                                this.btnLoading = false
                            } else {
                                await this.$store.dispatch('coreApi/bindThird', {
                                    grant_type: this.bindForm.grantType,
                                    open_code: this.bindForm.openId,
                                    redirect_uri: this.redirectUrlByThird
                                }).then(async res => {
                                    if(res.error) {
                                        let text = this.$t('homePage_model.edubind.tab1.err.text5')
                                        switch (res.error) {
                                            case 2:
                                                text = this.$t('homePage_model.edubind.tab1.err.text3')
                                                break
                                            case 13:
                                                text = this.$t('homePage_model.edubind.tab1.err.text4')
                                                break
                                        }
                                        this.bindErrText = text
                                        this.btnLoading = false
                                    } else {
                                        // 執行登入
                                        this.$store.dispatch('loginState', res)
                                    }
                                }).catch(() => {
                                    this.btnLoading = false
                                    this.$Message.warning({
                                        content: this.$t('auth_16'),
                                        duration: 5,
                                        closable: true
                                    })
                                })
                            }
                        } else {
                            this.bindErrText = this.$t('homePage_model.edubind.tab1.err.text1')
                        }
                    })
                break
                case 'douCheckLogin':
                    let _this = this
                    this.$Modal.confirm({
                        title: this.$t('homePage_model.edubind.tab2.doubleCheckModal.title'),
                        content: this.$t('homePage_model.edubind.tab2.doubleCheckModal.cont'),
                        onOk: async function() {
                            _this.btnLoading = true // 開啟加載畫面
                            _this.$store.dispatch('coreApi/authLogin', {
                                grant_type: _this.bindForm.grantType,
                                open_code: _this.bindForm.openId,
                                redirect_uri: this.redirectUrlByThird,
                                lang: this.pageLang
                            }).then(res => {
                                // 執行登入
                                _this.$store.dispatch('loginState', res)
                            }).catch((e) => {
                                _this.btnLoading = false
                                _this.bindErrText = _this.$t('homePage_model.edubind.tab1.err.text5')
                            })
                        },
                        cancelText: this.$t('homePage_model.edubind.tab2.doubleCheckModal.cancelText'),
                        okText: this.$t('homePage_model.edubind.tab2.doubleCheckModal.okText')
                    })
                break
                case 'sendVcode':
                    this.vCodeLoading = true

                    let data = {
                        country: this.wechatRgForm.countryCode,
                        account: this.accFormat,
                        lang: this.pageLang,
                        HasUser: false
                    }

                    this.$store.dispatch('coreApi/sendOTPCode', {
                        type: 'phone',
                        data: data
                    }).then(() => {
                        this.$Message.info({
                            content: this.$t('public_8'),
                            duration: 5
                        })
                        this.startCountdown()
                    }).catch((err) => {
                        let text = this.$t('error_16')
                        if(err.status) {
                            switch (err.status) {
                                case 429:
                                    text = this.$t('error_38')
                                    break
                            }
                        } else {
                            switch (err.error) {
                                case 1:
                                    text = this.$t('error_23')
                                    break
                            }
                        }
                        this.$Message.warning({
                            content: text,
                            duration: 7
                        })
                    }).finally(() => {
                        this.vCodeLoading = false
                    })

                break
                case 'wechatRgForm':
                    this.$refs[name].validate(async(valid) => {
                        if (valid) {
                        this.btnLoading = true // 開啟加載畫面
                            this.$store.dispatch('coreApi/authLogin', {
                                account: `+${this.wechatRgForm.countryCode}-${this.accFormat}`,
                                grant_type: this.wechatRgForm.grantType,
                                open_code: this.wechatRgForm.openId,
                                redirect_uri: this.redirectUrlByThird,
                                pin_code: this.wechatRgForm.vCode,
                                lang: this.pageLang
                            }).then(res => {
                                // 執行登入
                                this.$store.dispatch('loginState', res)
                            }).catch((e) => {
                                this.btnLoading = false
                            })
                        }
                    })
                break
                default:
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.$Spin.show() // 開啟加載畫面
                        this.$store.dispatch('coreApi/login', {
                            id: this.loginForm.loginId,
                            pass: this.loginForm.password
                        }).then(res => {
                            this.$store.dispatch('loginState', res)
                        }).catch(e => {
                            this.$Spin.hide()
                            this.$Message.warning({
                                content: this.$t('error_2'),
                                duration: 5,
                                closable: true
                            })
                        })
                    }
                })
            }
        },
        qrcodrLogin() {
            this.qrloginFlag = !this.qrloginFlag
            if (this.qrloginFlag && !this.sseSurvive) {
                // SSE 連線
                this.SEELink()
            }
        },
        SEELink: function() { // 開啟SSE連結
            if (!this.sseSurvive) {
                let apiUrl = profile.getQRCodeUrl()
                let es = new EventSourcePolyfill(apiUrl + '/service/sse', { headers: { 'X-Auth-Name': 'Account' } })
                let _this = this
                this.esState = es

                var closeSSE = function() {
                    if (_this.sseSurvive) {
                        es.close()
                        _this.sseSurvive = false
                    }
                }

                es.addEventListener('open', function(e) {
                    _this.sseSurvive = true
                }, false)

                // 取得登入網址
                es.addEventListener('message', function(e) {
                    if (e.data) {
                        let data = JSON.parse(e.data)
                        if (data.sid) {
                            let qrcodeURL = apiUrl + '/qrcode/qrcodelogin?sid=' + encodeURIComponent(data.sid, 'utf-8') + '&info=' + encodeURIComponent('TEAM Model', 'utf-8') + '&m=' + encodeURIComponent(_this.$t('homePage_25'), 'utf-8')
                            _this.crtQrcode(qrcodeURL)
                        } else if (data.code) {
                            closeSSE()
                            _this.codeLogin(data.code)
                        }
                    }
                }, false)

                // 錯誤
                es.addEventListener('error', function(e) {
                    closeSSE()
                }, false)

                // 設定五分鐘後關閉連接
                setTimeout(() => {
                    closeSSE()
                }, 300000)
            }
        },
        crtQrcode: function(url) { // 開啟QRCODE
            this.$nextTick(() => {
                if (this.joinQRcode === undefined) {
                    let qrcode = new QRCode('qrcode', {
                        width: 200, // 设置宽度，单位像素
                        height: 200, // 设置高度，单位像素
                        text: url // 设置二维码内容或跳转地址
                    })
                    this.joinQRcode = qrcode
                } else {
                    this.joinQRcode.clear()
                    this.joinQRcode.makeCode(url)
                }
            })
        },
        putUserCode: function(code, state) { // 如果第三方登入會啟動的function
            this.$Spin.show() // 開啟加載畫面
            this.$store.dispatch('coreApi/authLogin', {
                grant_type: state,
                open_code: code,
                redirect_uri: this.redirectUrlByThird,
                lang: this.pageLang
            }).then(res => {
                if(res.open_id && res.open_id.toLowerCase().indexOf('educloudtw-') > -1) { // 第一次使用教育雲登入，需選擇綁定醍摩豆帳號或直接登入
                    this.$Spin.hide()
                    this.bindForm.openId = res.open_id
                    this.bindForm.grantType = res.grant_type
                    this.validEducloudFlag = true
                } else if(res.open_id && res.open_id.toLowerCase().indexOf('wechat-') > -1) { // 第一次使用微信登入，需要驗證手機後登入
                    this.$Spin.hide()
                    this.wechatRgForm.openId = res.open_id
                    this.wechatRgForm.grantType = res.grant_type
                    this.validWechatFlag = true
                } else {
                    this.$store.dispatch('loginState', res)
                }
            }).catch((e) => {
                this.$Spin.hide()
                switch (e.error) {
                    case 10002:
                        this.$Modal.info({
                            title: this.$t('error_39_title'),
                            content: this.$t('error_39_content')
                        })
                        break
                    default:
                        this.$Message.warning({
                            content: this.$t('error_2'),
                            duration: 5,
                            closable: true
                        })
                }
            })
        },
        // 將open_code 轉給指定的位置
        jumpOCode: function(code, state) {
            this.$Spin.show() // 開啟加載畫面
            var stateJ
            let isError = false
            let existClientIdAry = ['4a6fd5c8-dfe2-4aef-ad9c-d5cb04488ae3', profile.clientID['cn'], profile.clientID['global']]

            try {
                stateJ = JSON.parse(Base64.decode(decodeURIComponent(state)))
            } catch (error) {
                console.log(error)
            }
            console.log(stateJ, 'stateJ')

            if (
                jsFn.isEmpty(stateJ) ||
                jsFn.isEmpty(stateJ.op_redirecturi) ||
                jsFn.isEmpty(stateJ.client_id) ||
                existClientIdAry.indexOf(stateJ.client_id) === -1
            ) {
                isError = true
            } else {
                try {
                    const url = new URL(stateJ.op_redirecturi)

                    const isValid =
                        url.hostname.endsWith('.teammodel.net') ||
                        url.hostname.endsWith('.teammodel.cn') ||
                        url.hostname === 'localhost'

                    if (!isValid) {
                        isError = true
                    }
                } catch (e) {
                    // 不是合法的 URL
                    isError = true
                }
            }

            if(!isError) {
                let accountVar = '?open_code=' + code // 必回的變數串要放在最前面
                let firstQuesNum = 0 // 第一個?號的位置
                let url = '' // 返回的網址
                let variable = '' // User 的變數
                let tmp = '' // 組成的網址

                // 檢查callback 網址裡面是否變數
                if (stateJ.op_redirecturi.indexOf('?') !== -1) { // 有
                    firstQuesNum = stateJ.op_redirecturi.indexOf('?')
                    url = stateJ.op_redirecturi.substring(0, firstQuesNum)
                    variable = stateJ.op_redirecturi.substring(firstQuesNum + 1)
                    tmp = url + accountVar + '&' + variable
                } else { // 沒有
                    tmp = stateJ.op_redirecturi + accountVar
                }

                sessionStorage.removeItem('callback')
                window.location.href = tmp
            } else {
                this.$Message.warning({
                    content: '沒有支援',
                    duration: 5,
                    closable: true
                })
            }
            this.$Spin.hide()
        },
        codeLogin: function(code) {
            this.$Spin.show() // 開啟加載畫面
            this.$store.dispatch('coreApi/codeLogin', code).then(res => {
                this.$store.dispatch('loginState', res)
            }).catch(() => {
                this.$Spin.hide()
                this.$Message.warning({
                    content: this.$t('快速登入失敗'),
                    duration: 5,
                    closable: true
                })
            })
        },
        closeSSE() {
            if(this.sseSurvive) {
                this.esState.close()
                this.sseSurvive = false
            }
        },
        startCountdown() {
            this.countdown = true
            this.reciprocal()
        },
        reciprocal() { // 調整倒數時間至可控
            this.verfTime -= 1
            if (this.verfTime === 0) {
                this.countdown = false
                this.verfTime = this.verCountdownSec
            } else {
                // 每秒執行一次,showTime()
                setTimeout(this.reciprocal, 1000)
            }
        }
    },
    mounted() {
        this.linkCount_1 = this.$refs.linkIcon_1.getElementsByTagName('li').length
        this.linkCount_2 = this.$refs.linkIcon_2.getElementsByTagName('li').length
        // 國碼預設值
        switch(this.pageLang) {
            case 'zh-tw':
                this.wechatRgForm.countryCode = 886
            break
            case 'zh-cn':
                this.wechatRgForm.countryCode = 86
            break
            case 'en-us':
                this.wechatRgForm.countryCode = 1
            break
        }
    },
    components: {
        CountryCode
    }
}
